import { Box, CircularProgress } from "@mui/material";

interface CenteredLoaderProps {
  size?: number;
  color?:
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | "inherit";
  thickness?: number;
}

const CenteredLoader = ({
  size = 40,
  color = "primary",
  thickness = 4,
}: CenteredLoaderProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    >
      <CircularProgress size={size} color={color} thickness={thickness} />
    </Box>
  );
};

export default CenteredLoader;
